import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import gsap from 'gsap'

export const initAlpine = () => {

	window.Alpine = Alpine
	window.gsap = gsap

	Alpine.plugin(collapse)

	
	Alpine.store('booking', {
		url: '',
		setUrl(url) {
			this.url = url
		}
	})
	
	Alpine.start()
}

export default () => { }